module.exports = __webpack_public_path__ + "static/media/grass_rustling.e17a0709.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/grass_rustling.mp3
// module id = 33
// module chunks = 0